<div class="customer-info row-block">
  <div class="customer-label">
    Name:
  </div>
  <div class="customer-span">
    <i class="pi pi-exclamation-triangle"
       style="font-size: 100%; color: #feca8a; margin-right: 0.3em;" *ngIf="nfsContact.id === -1"></i>
    {{nfsContact?.name}}
  </div>
</div>
<div class="customer-info row-block">
  <div class="customer-label">
    Phone #1:
  </div>
  <div class="customer-span margin-left-customer" (click)="callPhone()">
    {{nfsContact?.phone1}}
  </div>
</div>
<div class="customer-info row-block">
  <div class="customer-label">
    E-Mail:
  </div>
  <div class="customer-span margin-left-customer" (click)="sendEmail()">
    {{nfsContact?.email}}
  </div>
</div>
